import { collection, getDocs, limit, query, where } from "firebase/firestore";
import { db } from "../firebase";

const getEnterpriseInfo = async (domain) => {
  let isPersonalUserAccepted = false;

  try {
    const querySnapshot = await getDocs(
      query(
        collection(db, "enterprise"),
        where("domain", "==", domain),
        limit(1)
      )
    );

    isPersonalUserAccepted =
      !!querySnapshot.docs[0]?.data().isPersonalUserAccepted;
  } catch (error) {
    console.log(error);
  }

  return { isPersonalUserAccepted };
};

export default getEnterpriseInfo;
